export const formatCurrency = (amount) =>
  `R ${Number(amount).toLocaleString("en-ZA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-ZA", {
    day: "numeric", month: "short", year: "numeric",
  });

export const formatDateTime = (date) =>
  new Date(date).toLocaleString("en-ZA", {
    day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
  });

export const formatNumber = (num) => Number(num).toLocaleString("en-ZA");
